import useCanManageApiKeys from "shared/ApiKey/access/useCanManageApiKeys";
import useCanManageApiKey from "shared/ApiKey/access/useCanManageApiKey";
import { isApiKeyExpired } from "shared/ApiKey/helpers";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import { showResetConfirmation } from "components/ApiKeys/ResetConfirmation";
import useTypedContext from "hooks/useTypedContext";
import { ApiKeyType } from "types/generated";
import { showManageRolesDrawer } from "views/Account/Settings/ApiKey/ManageRolesDrawer";

import { showApiKeysEditDrawer } from "../../../ApiKey/EditDrawer";
import { showApiKeysManageGroupsDrawer } from "../../../ApiKey/ManageGroupsDrawer";
import { CellComponentProps } from "../types";
import { SettingsContext } from "../../../Context";

type ApiKeysListItemDropdownActionsCellProps = CellComponentProps;

const ApiKeysListItemDropdownActionsCell = ({
  apiKey,
  refetchQueriesOnDelete,
  refetchQueriesOnUpdate,
}: ApiKeysListItemDropdownActionsCellProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);
  const canManageApiKeys = useCanManageApiKeys();
  const canManageApiKey = useCanManageApiKey(apiKey);
  const isExpired = isApiKeyExpired(apiKey.expiresAt);

  const onDeleteClick = () => {
    showDeleteConfirmation({
      name: apiKey.name,
      id: apiKey.id,
      refetchQueriesOnDelete,
    });
  };

  const onResetClick = () => {
    showResetConfirmation({
      name: apiKey.name,
      id: apiKey.id,
    });
  };

  const onManageRolesClick = () => {
    showManageRolesDrawer({
      apiKeyId: apiKey.id,
      activationStatus,
    });
  };

  const onEditDetailsClick = () => {
    showApiKeysEditDrawer({
      apiKey,
      refetchQueriesOnUpdate,
    });
  };

  const onManageGroupsClick = () => {
    showApiKeysManageGroupsDrawer({
      apiKey,
      activationStatus,
      refetchQueriesOnUpdate,
    });
  };

  return (
    <DropdownMenuEllipsis tooltip="API key actions">
      {canManageApiKey && (
        <DropdownMenuItem onAction={onEditDetailsClick}>Edit details</DropdownMenuItem>
      )}
      <DropdownMenuItem onAction={onManageRolesClick}>Manage roles</DropdownMenuItem>
      {canManageApiKeys && (
        <DropdownMenuItem onAction={onManageGroupsClick}>Manage groups</DropdownMenuItem>
      )}
      {canManageApiKey && apiKey.type === ApiKeyType.Secret && !isExpired && (
        <DropdownMenuItem onAction={onResetClick}>Reset</DropdownMenuItem>
      )}
      {canManageApiKey && (
        <DropdownMenuItem onAction={onDeleteClick} danger>
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default ApiKeysListItemDropdownActionsCell;
